"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bottomAlignedText = exports.smallText = exports.mediumText = exports.sevenCharText = exports.sixCharText = exports.largeText = exports.CONFIG = void 0;
exports.CONFIG = {
    labelLength: 2,
    labelWidth: 2,
    format: [2, 2],
    orientation: 'l',
    verticalMargin: 0.1,
    leftMargin: 0.0575
};
const allText = (doc, textYPos, text, multiLine, fontSize, lineSpace) => {
    var _a;
    doc.setFontSize(fontSize);
    textYPos += lineSpace;
    if (!multiLine)
        doc.text(text, exports.CONFIG.leftMargin, textYPos);
    else {
        const linesOfContent = doc.splitTextToSize(text !== null && text !== void 0 ? text : 'missing content', exports.CONFIG.labelWidth - 2 * exports.CONFIG.leftMargin);
        doc.text(linesOfContent, exports.CONFIG.leftMargin, textYPos);
        textYPos += (((_a = linesOfContent.length) !== null && _a !== void 0 ? _a : 1) - 1) * lineSpace;
    }
    return textYPos;
};
const largeText = (doc, textYPos, text) => {
    doc.setFont('helvetica', 'bold');
    const yPos = allText(doc, textYPos, text, false, 46, 0.6);
    doc.setFont('helvetica', 'normal');
    return yPos;
};
exports.largeText = largeText;
// 38 font size for 6 characters
const sixCharText = (doc, textYPos, text) => {
    doc.setFont('helvetica', 'bold');
    const yPos = allText(doc, textYPos, text, false, 38, 0.6);
    doc.setFont('helvetica', 'normal');
    return yPos;
};
exports.sixCharText = sixCharText;
// 32 font size for 7 characters
const sevenCharText = (doc, textYPos, text) => {
    doc.setFont('helvetica', 'bold');
    const yPos = allText(doc, textYPos, text, false, 32, 0.6);
    doc.setFont('helvetica', 'normal');
    return yPos;
};
exports.sevenCharText = sevenCharText;
const mediumText = (doc, textYPos, text, multiLine = false) => {
    return allText(doc, textYPos, text, multiLine, 16, 0.25);
};
exports.mediumText = mediumText;
const smallText = (doc, textYPos, text, multiLine = false) => {
    return allText(doc, textYPos, text, multiLine, 10, 0.18);
};
exports.smallText = smallText;
/**
 * Align text to end of doc
 * @param doc jspdf doc
 * @param lines text lines ordered from top to bottom
 */
const bottomAlignedText = (doc, lines) => {
    let textYPos = exports.CONFIG.labelLength - exports.CONFIG.verticalMargin;
    lines.reverse().forEach((line) => {
        doc.text(line, exports.CONFIG.leftMargin, textYPos);
        textYPos -= 0.18;
    });
};
exports.bottomAlignedText = bottomAlignedText;
//# sourceMappingURL=utils.js.map